module.exports = __webpack_public_path__ + "static/media/po-undercarriage-2.8175de7f.png";